import { render } from "./NoticeListComponent.vue?vue&type=template&id=15959cc7"
import script from "./NoticeListComponent.vue?vue&type=script&lang=js"
export * from "./NoticeListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__